import API from "./index";

class LocalArmazenamentoService {
  constructor() {
    this.path = `/api/local-armazenamento`;
  }



  delete(id){

    return API.delete(`${this.path}/${id}`);

  }
}


export default LocalArmazenamentoService;
